import { getv4LocaleFromI18nLocale } from "~/scripts/useful-functions"
import { createUrl } from "~/scripts/api-resource"
import type { AxiosInstance } from "axios"
import type { RuntimeConfig } from "#app"

export class PartnerService {
  private axios: AxiosInstance
  private config: RuntimeConfig

  constructor(axios: AxiosInstance, config: RuntimeConfig) {
    this.axios = axios
    this.config = config
  }

  async getStores(ident: any, locale: string): Promise<any> {
    const storeIndex = createUrl(this.config.v4Host + "/ng/api/v3/affiliates/" + ident + "/stores")
    let response

    try {
      response = await this.axios.get(
        storeIndex,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
    } catch (e) {
      console.log("There was an error", e)
    }

    return response
  }

  async getStorageUnits(ident: any, locale: string): Promise<any> {
    const storageUnitIndex = createUrl(this.config.v4Host + "/ng/api/v3/affiliates/" + ident + "/storage-units")
    let response

    try {
      response = await this.axios.get(
        storageUnitIndex,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
    } catch (e) {
      console.log("There was an error", e)
    }

    return response
  }
}
